module.exports = __webpack_public_path__ + "static/img/dbbk.220ac67.png";


//////////////////
// WEBPACK FOOTER
// ./static/tg_images/dbbk.png
// module id = Fvae
// module chunks = 5